import { patientAction } from '../../actions/constant';

const {
  GET_THERAPIST_DISCIPLINE_FAILURE,
  GET_THERAPIST_DISCIPLINE_SUCCESS,
  GET_THERAPIST_DISCIPLINE_LOADING,
} = patientAction;

const intitialstate: object = {
  ptResponse: null,
  otResponse: null,
  slpResponse: null,
  loading: false,
};

export const getAllTherapistDisciplineReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_THERAPIST_DISCIPLINE_SUCCESS: {
      return {
        ...state,
        ptResponse: action.payload?.ptResponse,
        otResponse: action.payload?.otResponse,
        slpResponse: action.payload?.slpResponse,
        loading: false,
      };
    }

    case GET_THERAPIST_DISCIPLINE_FAILURE:
      return {
        ...state,
        ptResponse: null,
        otResponse: null,
        slpResponse: null,
        loading: false,
      };

    case GET_THERAPIST_DISCIPLINE_LOADING:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
